'use client';
import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

interface Value {
    title: string;
    description: string;
}

const values: Value[] = [
    {
        title: 'Technology-Enabled',
        description: 'Investing in cutting-edge technology to provide comprehensive drayage solutions for the future.'
    },
    {
        title: 'Ultra-Flexible',
        description: "Creating a carrier model that adapts to meet our customers' varying needs."
    },
    {
        title: 'National Network',
        description: 'Building robust asset fleets across key hubs and partnerships in all major ports.'
    },
    {
        title: 'Operational Excellence',
        description: 'Leveraging over a decade of operational experience to deliver superior service.'
    }
];

const OurMission: React.FC = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                            Our Mission
                        </h2>
                        <p className="text-lg text-gray-600 mb-8">
                            Junction Integrated Logistics has set out to become the leading provider of drayage 
                            and destination management solutions in the USA by creating a technology-enabled, 
                            ultra-flexible carrier model that meets our customers&apos; varying needs. We are building 
                            a robust national network with asset fleets across key hubs and partners in all major 
                            ports to empower shippers to navigate market fluctuations with confidence. Building 
                            upon over a decade of operational experience, along with strategic investment in 
                            cutting-edge technology, we are providing the comprehensive drayage solution for the future.
                        </p>

                        <div className="grid gap-6">
                            {values.map((value, index) => (
                                <div key={index} className="flex items-start space-x-4">
                                    <div className="flex-shrink-0">
                                        <div className="h-8 w-8 rounded-full bg-[#29abe2] bg-opacity-10 flex items-center justify-center">
                                            <CheckCircleIcon className="h-5 w-5 text-[#29abe2]" />
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                            {value.title}
                                        </h3>
                                        <p className="text-gray-600">
                                            {value.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="relative h-[600px] rounded-2xl overflow-hidden">
                        <img
                            src="/images/mission-values.jpg"
                            alt="Our Mission and Values"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurMission; 